// extracted by mini-css-extract-plugin
export default {"container":"Question_container__GqLeD","textArea":"Question_textArea__Fdd+E","question":"Question_question__zWLo3","prefix":"Question_prefix__HpwH4"};